import { DEFAULT_LOCALE, SupportedLocale } from '@msdk/definitions'
import { atom } from 'recoil'

/**
 * Object that contains i18n translations
 * loaded incrementally when need a domain specific translation
 */
export interface Translation {
  /**
   * Hashed value of the version
   */
  version: string
  /**
   * Translation records
   */
  data: Record<string, { msName: string; sectionName: string; tDescription: string; isSystem: boolean }>
  /**
   * Chached translations for different domain
   */
  loadedSections: SectionByMicroservice[]
  /**
   * Current selected locale
   */
  currentLocale: SupportedLocale
}

export interface SectionByMicroservice {
  msName: string
  sectionName: string
}

const TRANS_INIT_VALUE: Translation = {
  currentLocale: DEFAULT_LOCALE,
  data: {},
  loadedSections: [],
  version: '',
}

export const $translationCtx = atom<Translation>({
  key: 'i18n',
  default: TRANS_INIT_VALUE,
})
